import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Location } from "../../../@types/location";
import axiosInstance from "../../../utils/axiosConfig";
export const findLocation = createAsyncThunk(
  "locations/findOne",
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}location/${id}`);
      return data as Location;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
